export default "__VITE_ASSET__CsqY$Py1__$_?nuxt_component=async&nuxt_component_name=IconFrameShapePanto&nuxt_component_export=default__"